import React from 'react';
import {
  clickPageTrack,
  getPathnameForAnalytics,
} from 'common/utils/client-analytics.util';
import { S } from './style';

export const NavbarElement = ({
  isActive,
  name,
  Icon,
  path,
  t,
  dataTestID,
}) => (
  <S.NavbarItem
    onClick={clickPageTrack(`go_to_${getPathnameForAnalytics(path)}`)}
    active={isActive ? 'true' : ''}
    to={path}
    data-testid={dataTestID}
  >
    {Icon && (
      <S.NavbarIcon active={isActive ? 'true' : ''}>
        <Icon />
      </S.NavbarIcon>
    )}
    <S.NavbarText>{t(name)}</S.NavbarText>
  </S.NavbarItem>
);
